"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.FieldIcon = exports.ChipBox = exports.CheckboxHidden = exports.CheckIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var CheckboxHidden = _styledComponents.default.input.withConfig({
  componentId: "sc-wtyezb-0"
})(["position:absolute;overflow:hidden;width:0;height:0;border:0;padding:0;margin:0;overflow:hidden;opacity:0;"]);

exports.CheckboxHidden = CheckboxHidden;

var Label = _styledComponents.default.label.withConfig({
  componentId: "sc-wtyezb-1"
})(["cursor:pointer;display:inline-flex;flex-direction:row;align-items:center;"]);

exports.Label = Label;

var FieldIcon = _styledComponents.default.i.withConfig({
  componentId: "sc-wtyezb-2"
})(["display:flex;transition:0.2s all linear;"]);

exports.FieldIcon = FieldIcon;

var ChipBox = _styledComponents.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['color', 'appearance', 'margin'].includes(prop);
  }
}).withConfig({
  componentId: "sc-wtyezb-3"
})(["", ""], function (_ref) {
  var _ref$appearance = _ref.appearance,
      normal = _ref$appearance.normal,
      hover = _ref$appearance.hover,
      checked = _ref$appearance.checked,
      radio = _ref$appearance.radio,
      disabled = _ref$appearance.disabled,
      size = _ref.size,
      theme = _ref.theme;
  return "\n    display: inline-flex;\n    transition: 0.2s all linear;\n    border-radius: ".concat(size.borderRadius, ";\n    background: transparent;\n    border: ").concat(_tokens.borderWidth.md, "px solid ").concat(normal.borderColor, ";\n    &:hover{\n      border-color: ").concat(hover.borderColor, ";\n    }\n    & ").concat(Label, "{\n      padding-top:").concat(size.padding.top, "px;\n      padding-right:").concat(size.padding.right, "px;\n      padding-bottom:").concat(size.padding.bottom, "px;\n      border-radius: ").concat(size.borderRadius, ";\n      padding-left:").concat(size.padding.left, "px;\n      color: ").concat(normal.color, ";\n      font-family: ").concat(theme.fonts.default, ", sans-serif;\n      font-weight: ").concat(size.label.fontWeight, ";\n      font-size: ").concat(size.label.fontSize, "px;\n      letter-spacing: ").concat(size.label.letterSpacing, "px;\n      line-height: ").concat(size.label.lineHeight, "px;\n    }\n    & ").concat(FieldIcon, "{\n      svg {\n        fill:  ").concat(_tokens.colors.neutral950, ";\n        width: ").concat(size.icon.width, "px;\n        height: ").concat(size.icon.height, "px;\n      }\n      margin-right: ").concat(size.icon.margin, "px;\n    }\n    & ").concat(FieldIcon, ".icon-right{\n      margin-left: ").concat(size.icon.margin, "px;\n      margin-right: 0px;\n    }\n    &.checked {\n      border-color: ").concat(checked.borderColor, ";\n      background: ").concat(checked.background, ";\n      ").concat(Label, " {\n        ").concat(FieldIcon, ":first-child{\n          svg {\n            fill: ").concat(checked.svgColor, ";\n          }\n        }\n      }\n    }\n    &.disabled {\n      border-color: ").concat(disabled.borderColor, ";\n      background: ").concat(disabled.background, ";\n      ").concat(Label, "{\n        color: ").concat(disabled.color, ";\n        ").concat(FieldIcon, ":first-child{\n          svg {\n            fill: ").concat(disabled.color, ";\n          }\n        }\n      }\n      ").concat(FieldIcon, "{\n        svg{\n          fill:").concat(disabled.color, " ;\n        }\n      }\n    }\n  ");
});

exports.ChipBox = ChipBox;

var CheckIcon = function CheckIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.7133 0.48421L3.80744 7.39012L1.28665 4.84307C1.15536 4.73804 0.945295 4.73804 0.840263 4.84307L0.0787746 5.60456C-0.0262582 5.70959 -0.0262582 5.91966 0.0787746 6.05095L3.59737 9.54329C3.72867 9.67458 3.91247 9.67458 4.04376 9.54329L11.9212 1.66583C12.0263 1.5608 12.0263 1.35073 11.9212 1.21944L11.1597 0.48421C11.0547 0.352919 10.8446 0.352919 10.7133 0.48421Z"
  }));
};

exports.CheckIcon = CheckIcon;